export default __webpack_public_path__ + "static/logos-tiles-dpr-06aa8fb697a6ac00139f7a5697fcc9e1.svg";